"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEnumsService = exports.getDefaultState = void 0;
function getDefaultState() {
    return {
        enums: {}
    };
}
exports.getDefaultState = getDefaultState;
/**
 * Creates a EnumsService which stores Spring enums.
 *
 * Exposes a subscription to anyone who wants to listen to the
 * changes to the EnumsState.
 */
function makeEnumsService() {
    let state = getDefaultState();
    let subscribers = [];
    function getState() {
        return state;
    }
    function subscribe(subscriber) {
        subscribers.push(subscriber);
        subscriber(state);
    }
    function informSubscribers() {
        subscribers.forEach((subscriber) => subscriber(Object.assign({}, state)));
    }
    function setEnums(enums) {
        state = { enums };
        informSubscribers();
    }
    function unsubscribe(subscriber) {
        subscribers = subscribers.filter((s) => s !== subscriber);
    }
    return {
        getState,
        subscribe,
        unsubscribe,
        setEnums
    };
}
exports.makeEnumsService = makeEnumsService;
